import { resolveAdmindeskApiBaseConfig } from '@imobdesk/env'
import { getImobdeskEnvRecord } from '@/lib/imobdesk-env-record'

const envRecord = getImobdeskEnvRecord()

const { baseUrl, devDirectBaseUrl } = resolveAdmindeskApiBaseConfig(envRecord, {
  isDev: import.meta.env.DEV,
})

export const API_BASE_URL = baseUrl
export const DEV_API_DIRECT_BASE_URL = devDirectBaseUrl

if (import.meta.env.DEV) {
  console.log(
    '🔗 API:',
    API_BASE_URL.startsWith('/')
      ? `${API_BASE_URL} (proxy Vite → veja vite.config; VITE_IMOBDESK_API_URL define o host do Nest)`
      : API_BASE_URL,
  )
}

export const API_ENDPOINTS = {
  auth: {
    login: '/auth/login',
  },
  workspace: {
    profile: '/workspace/profile',
  },
} as const
